import React, { Component } from "react";
import "./Modal.css";

class Modal extends Component {
  state = {
    open: false,
    clicked: false
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.status === true) {
      this.setState({ open: true, clicked: true });
      document.querySelector(".modal-background-shadow").style.opacity = 0.4;
      document.querySelector(".modal-background-shadow").style.zIndex = 2;
      document.querySelector(".modal-body").style.opacity = 1;
      document.querySelector(".modal-body").style.zIndex = 2;
      document.querySelector("body").style.height = "100%";
      document.querySelector("body").style.overflow = "hidden";
    }
  };

  handleModalClose = () => {
    const { open, clicked } = this.state;
    if (open && clicked) {
      document.querySelector(".modal-background-shadow").style.opacity = 0;
      document.querySelector(".modal-background-shadow").style.zIndex = 0;
      document.querySelector(".modal-body").style.opacity = 0;
      document.querySelector(".modal-body").style.zIndex = 0;
      document.querySelector("body").style.height = null;
      document.querySelector("body").style.overflow = null;
      this.setState({ open: false, clicked: false });
      this.props.changeState();
    }
  };

  render() {
    return (
      <div className="modal-container">
        <div
          className="modal-background-shadow"
          onClick={() => {
            this.handleModalClose();
          }}
        />
        <div className="modal-body">
          <p>Thank you for your inquiry! You will receive an email at the address you provided.</p>
          <button
            className="btn"
            onClick={() => {
              this.handleModalClose();
            }}
          >
            close
          </button>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Common/Modal.js